/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AnnouncementsLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABbklEQVR4nNWUvUrDUBTHoyAFB531FRwUXVUcr5rzkSE5p+2mkE0cRZcsDuIz6FPoLljqcwiCi1oFl/qByk1baUtqk5oMPXAgN/mf/+/e3HOv44xDIMs+kNy3UvdyNSeSNWT9RtILILlE1i+Xy6u5AYD10AKMMSWb9tm+y8u8Hs8+KUlqmQ2NMaVtL1jsjAeatzOVaRRFk0SygaxnwPIMpJ+5AAB0AUhPgeRuUGEmAFF5y5oB6VMMIHkfVpgJ0D3TocWo87GGpDZIA6zXPYB+8l8AIDlItYGjA/TNQjoryR2AQ7Kzj4UBMKlFM20yjwBwWTZbbSqPhQD641dMclsowHGcCcRgHUjO8wY0rdCY6kw8RvXaHfIKrFfI+vEvgD2J7V90g6xRVxPs2O+eV50DkiMgfRkJQFRZQpaHnv5mrYdhONWtY66sIEujD9B00oTv+7PAEiLrCZDsuq47naRzvWDZrtRekK1TrsepAGMRP51ECbRK/Kq+AAAAAElFTkSuQmCC)
 */
export const AnnouncementsLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 4h.5v-.5a2.5 2.5 0 0 1 5 0V4h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm4-.5V4h-2v-.5a1 1 0 1 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12.33 5.74a.5.5 0 0 1 .67.47V9a3 3 0 0 0 3 3h5.5c.28 0 .5.22.5.5v8c0 .83-.67 1.5-1.5 1.5h-.94a3 3 0 0 1-2.46-1.28 3.86 3.86 0 0 0-1.07-1.03l-2.36-.94a.92.92 0 0 0-1.23.63 2.92 2.92 0 0 1-3.55 2.12l-.62-.15A3 3 0 0 1 6 18.44V8.35c0-.2.13-.4.33-.47l6-2.14Zm-1.3 12.06L8 16.7v1.73a1 1 0 0 0 .76.97l.62.15c.5.13 1-.17 1.12-.67.1-.41.29-.78.53-1.1Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 10c0-1.1.9-2 2-2h.5c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5H4a2 2 0 0 1-2-2v-4Z"
        className={colorClass}
      />
    </svg>
  );
};
